import Vue from 'vue';
import Vuex from 'vuex';

import addresses from './modules/addresses';
import auth from './modules/auth';
import billboard from './modules/billboard';
import blog from './modules/blog';
import cart from './modules/cart';
import checkout from './modules/checkout';
import contact from './modules/contact';
import dispatchPortal from './modules/dispatchPortal';
import driverApplication from './modules/driverApplication'
import navbar from './modules/navbar';
import orders from './modules/orders';
import products from './modules/products';
import profile from './modules/profile';
import recipe from './modules/recipe';
import search from './modules/search';
import utils from './modules/utils';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    addresses,
    auth,
    billboard,
    blog,
    cart,
    checkout,
    contact,
    driverApplication,
    dispatchPortal,
    navbar,
    orders,
    products,
    profile,
    recipe,
    search,
    utils,
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js